import React from 'react';
import { Typography, Button, Box } from '@mui/material'; // Import Material-UI components
import axios from 'axios'; // Import Axios for making HTTP requests

const Logout = () => {
  // Function to handle logout
  const handleLogout = async () => {
    try {
      // Make a POST request to the logout endpoint
      await axios.post('/logout');
      console.log('User logged out successfully');
      // Perform any additional actions after logout (e.g., redirecting)
    } catch (error) {
      console.error('Error logging out:', error);
    }
  };

  return (
    <Box textAlign="center" mt={2}>
      <Typography variant="body1" mb={2}>
        To securely log out, click the button below:
      </Typography>
      <Button variant="contained" color="primary" onClick={handleLogout}>
        Logout
      </Button>
    </Box>
  );
};

export default Logout;
